export type DutyRecurrenceFrequency = 'NONE' | 'DAILY' | 'WEEKLY' | 'MONTHLY';

export interface DutyRecurrenceOption {
  id: DutyRecurrenceFrequency;
  labelKey: string;
  icon: string;
}

export const DUTY_RECURRENCE_OPTIONS: DutyRecurrenceOption[] = [
  {
    id: 'NONE',
    labelKey: 'app.components.addDutyDialog.recurrence.once',
    icon: '/public/svgs/recurrence-once.svg',
  },
  {
    id: 'DAILY',
    labelKey: 'app.components.addDutyDialog.recurrence.daily',
    icon: '/public/svgs/recurrence-daily.svg',
  },
  {
    id: 'WEEKLY',
    labelKey: 'app.components.addDutyDialog.recurrence.weekly',
    icon: '/public/svgs/recurrence-weekly.svg',
  },
  {
    id: 'MONTHLY',
    labelKey: 'app.components.addDutyDialog.recurrence.monthly',
    icon: '/public/svgs/recurrence-monthly.svg',
  },
];

export function recurrenceLabelKey(
  frequency?: string | null,
): string | null {
  if (!frequency || frequency === 'NONE') return null;
  const option = DUTY_RECURRENCE_OPTIONS.find((o) => o.id === frequency);
  return option?.labelKey ?? null;
}

export function recurrenceIcon(frequency?: string | null): string | null {
  if (!frequency || frequency === 'NONE') return null;
  const option = DUTY_RECURRENCE_OPTIONS.find((o) => o.id === frequency);
  return option?.icon ?? null;
}
